import { times } from "lodash";

class Planer {

    outputs = {
        energy: {
            $needed: null,
            $logged: null,
            $intervention: null,
            $interventionLogged: null,
            $difference: null,
            $percentage: null,
        },
        protein: {
            $min: null,
            $max: null,
            $logged: null,
            $interventionLogged: null,
            $difference: null,
            $percentage: null,
        },
    };

    energy = {
        difference: 0,
        percentage: 0,
        interventionLogged: 0,
        total: 0,
    };

    protein = {
        difference: 0,
        percentage: 0,
        interventionLogged: 0,
        total: 0,
    };

    stateClasses = {
        sufficent: 'calculation__row--sufficent',
        insufficent: 'calculation__row--insufficent',
    };

    constructor($el, nutritionLog, interventions, implementations) {
        this.$el = $el;
        this.nutritionLog = nutritionLog;
        this.interventions = interventions;
        this.implementations = implementations;
        this.planerStep = this.$el.data('planer-step') ? this.$el.data('planer-step') : 7;

        // outputs
        this.outputs.energy.$needed = this.$el.find('[data-planer="energy-needed"]');
        this.outputs.energy.$intervention = this.$el.find('[data-planer="energy-intervention"]');
        this.outputs.energy.$logged = this.$el.find('[data-planer="energy-logged"]');
        this.outputs.energy.$difference = this.$el.find('[data-planer="energy-differenz"]');
        this.outputs.energy.$percentage = this.$el.find('[data-planer="energy-percentage"]');
        this.outputs.energy.$interventionLogged = this.$el.find('[data-planer="energy-intervention-logged"]');
        this.outputs.energy.$total = this.$el.find('[data-planer="energy-total"]');

        this.outputs.protein.$min = this.$el.find('[data-planer="protein-min"]');
        this.outputs.protein.$max = this.$el.find('[data-planer="protein-max"]');
        this.outputs.protein.$logged = this.$el.find('[data-planer="protein-logged"]');
        this.outputs.protein.$difference = this.$el.find('[data-planer="protein-differenz"]');
        this.outputs.protein.$percentage = this.$el.find('[data-planer="protein-percentage"]');
        this.outputs.protein.$intervention = this.$el.find('[data-planer="protein-intervention"]');
        this.outputs.protein.$interventionLogged = this.$el.find('[data-planer="protein-intervention-logged"]');
        this.outputs.protein.$total = this.$el.find('[data-planer="protein-total"]');

        this.$separator = this.$el.find('[data-planer="separator"]');

        // percentage rows
        this.$energy_row = this.$el.find('[data-planer="energy-row"]');
        this.$protein_row = this.$el.find('[data-planer="protein-row"]');

        this.init();
    }

    init = () => {
        this.nutritionLog.$el.on('changed', this.valuesChanged);
        this.interventions.$el.on('changed', this.valuesChanged);

        this.implementations.forEach(implementation => {
            implementation.$el.on('change', this.valuesChanged);
        });
        this.valuesChanged();
    }

    valuesChanged = () => {
        // calculate bilanz & percentace
        this.calculateInterventionsLogged();
        this.calculateDifference();

        // output values
        this.outputValues();
    }

    calculateDifference = () => {
        let proteinTarget = 0;
        let proteinTotal = 0;
        let energyTotal = 0;


        const energyTarget = this.nutritionLog.bmrCalculator.energy;
        // @TODO: effektive Intervention ergänzen

        if (this.planerStep == 6) {
            energyTotal = this.nutritionLog.total.energy + this.energy.interventionLogged;
        } else if (this.planerStep == 7) {
            energyTotal = this.nutritionLog.total.energy + this.interventions.total.energy;
        }

        // old
        // energyTotal = this.nutritionLog.total.energy + this.interventions.total.energy + this.energy.interventionLogged;
        this.energy.total = energyTotal;
        this.energy.difference = energyTotal - energyTarget;
        this.energy.percentage = Number.parseFloat((energyTotal / energyTarget) * 100).toFixed(0);

        proteinTarget = this.nutritionLog.bmrCalculator.protein.min;
        // @TODO: effektive Intervention ergänzen

        if (this.planerStep == 6) {
            proteinTotal = this.nutritionLog.total.protein + this.protein.interventionLogged;
        } else if (this.planerStep == 7) {
            proteinTotal = this.nutritionLog.total.protein + this.interventions.total.protein;
        }
        // old
        // proteinTotal = this.nutritionLog.total.protein + this.interventions.total.protein + this.protein.interventionLogged;
        this.protein.total = proteinTotal;
        this.protein.difference = proteinTotal - proteinTarget;
        this.protein.percentage = Number.parseFloat((proteinTotal / proteinTarget) * 100).toFixed(0);


    }

    calculateInterventionsLogged = () => {
        let energy = 0;
        let protein = 0;

        this.implementations.forEach(implementation => {
            energy += parseInt(implementation.implementation.energy, 10);
            protein += parseInt(implementation.implementation.protein, 10);
        });

        this.energy.interventionLogged = energy;
        this.protein.interventionLogged = protein;
    }

    outputValues = () => {
        // energy
        this.outputs.energy.$needed.text(this.nutritionLog.bmrCalculator.energy);
        this.outputs.energy.$logged.text(this.nutritionLog.total.energy);
        this.outputs.energy.$intervention.text(this.interventions.total.energy);
        this.outputs.energy.$difference.text(this.energy.difference > 0 ? `+${this.energy.difference}` : this.energy.difference);
        this.outputs.energy.$percentage.text(`${this.energy.percentage}%`);
        this.outputs.energy.$interventionLogged.text(this.energy.interventionLogged);
        this.outputs.energy.$total.text(this.energy.total);

        if (this.energy.percentage < 100) {
            this.$energy_row.addClass(this.stateClasses.insufficent);
            this.$energy_row.removeClass(this.stateClasses.sufficent);
        } else {
            this.$energy_row.addClass(this.stateClasses.sufficent);
            this.$energy_row.removeClass(this.stateClasses.insufficent);
        }

        // protein
        this.outputs.protein.$min.text(this.nutritionLog.bmrCalculator.protein.min);
        this.outputs.protein.$max.text(this.nutritionLog.bmrCalculator.protein.max);
        this.outputs.protein.$logged.text(this.nutritionLog.total.protein);
        this.outputs.protein.$intervention.text(this.interventions.total.protein);
        this.outputs.protein.$difference.text(this.protein.difference > 0 ? `+${this.protein.difference}` : this.protein.difference);
        this.outputs.protein.$percentage.text(`${this.protein.percentage}%`);
        this.outputs.protein.$interventionLogged.text(this.protein.interventionLogged);
        this.outputs.protein.$total.text(this.protein.total);

        if (this.protein.percentage < 100) {
            this.$protein_row.addClass(this.stateClasses.insufficent);
            this.$protein_row.removeClass(this.stateClasses.sufficent);
        } else {
            this.$protein_row.addClass(this.stateClasses.sufficent);
            this.$protein_row.removeClass(this.stateClasses.insufficent);
        }

        if (this.nutritionLog.bmrCalculator.protein.min != 0 && (this.nutritionLog.bmrCalculator.protein.min == this.nutritionLog.bmrCalculator.protein.max)) {
            this.$separator.addClass('d-none');
            this.outputs.protein.$max.addClass('d-none');
        } else {
            this.$separator.removeClass('d-none');
            this.outputs.protein.$max.removeClass('d-none');
        }

    }
}

export default Planer;
